import { api } from "./index";

export interface BidSubmissionDocument {
  id: string;
  bidSubmissionId: string;
  fileName: string;
  originalName?: string;
  fileSize: number;
  mimeType: string;
  documentType: string;
  title?: string;
  description?: string;
  uploadedAt: string;
  uploadedById?: string;
  status: 'PENDING' | 'APPROVED' | 'REJECTED';
  reviewNotes?: string;
  reviewedById?: string;
  reviewedAt?: string;
  vendorDocumentId?: string;
}

export interface UploadDocumentResponse {
  document: BidSubmissionDocument;
  message: string;
}

export const bidSubmissionDocumentsApi = {
  uploadDocument: (bidSubmissionId: string, formData: FormData) =>
    api.post<UploadDocumentResponse>(`/bid-submissions/${bidSubmissionId}/documents`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }),

  listDocuments: (bidSubmissionId: string): Promise<BidSubmissionDocument[]> =>
    api.get(`/bid-submissions/${bidSubmissionId}/documents`).then((res) => res.data),

  removeDocument: (documentId: string) =>
    api.delete(`/bid-submission-documents/${documentId}`),

  downloadDocument: (documentId: string, useVendorAuth: boolean = false) =>
    api.get(`/bid-submission-documents/${documentId}/download`, {
      responseType: "blob",
      useVendorAuth,
    }),
};
